module.exports = __webpack_public_path__ + "img/f3-1.ad423030.png";